module.exports = __webpack_public_path__ + "img/banner.bfd6a59d.jpg";